import axiosInstance from '../../Config/axiosConfig';

// Search for users to match with
export const searchUsers = async (filters = {}) => {
  try {
    const response = await axiosInstance.post('/user/search', filters, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data.data; // Return the array of users
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const getUserProfile = async (userId) => {
  try {
    const response = await axiosInstance.get(`/user/profile/${userId}`);
    return response.data.data; // Return the array of users
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

// Like a user
export const likeUser = async (userId) => {
  try {
    const response = await axiosInstance.get(`/user/like/${userId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data; // Return the response data
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

// Pass on a user
export const passUser = async (userId) => {
  try {
    const response = await axiosInstance.get(`/user/pass/${userId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data; // Return the response data
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

// Favorite a user
export const favoriteUser = async (userId) => {
  try {
    const response = await axiosInstance.post(`/user/favorite/${userId}`);
    return response.data; // Return the response data
  } catch (error) {
    console.error('Favorite user error:', error);
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};